export default function Services() {
  const services = [
    {
      image: 'https://public.readdy.ai/ai/img_res/73b50e637ef414b44030e54f3120f465.jpg',
      category: 'Wheelchair Transport',
      title: 'Wheelchair Accessible Vehicles',
      description: 'Fully equipped vans with hydraulic lifts and secure wheelchair restraints for safe, comfortable transportation.'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Professional%20medical%20transportation%20driver%20assisting%20ambulatory%20patient%2C%20caring%20healthcare%20worker%20helping%20elderly%20person%2C%20compassionate%20medical%20transport%20service%2C%20clean%20professional%20uniform%2C%20simple%20clean%20background%2C%20warm%20caring%20atmosphere%2C%20professional%20healthcare%20assistance&width=600&height=500&seq=service-ambulatory-002&orientation=portrait',
      category: 'Ambulatory Services',
      title: 'Door-to-Door Assistance',
      description: 'Trained professionals provide personalized assistance for patients who can walk but need extra support.'
    },
    {
      image: 'https://readdy.ai/api/search-image?query=Medical%20stretcher%20transport%20vehicle%20interior%2C%20professional%20gurney%20transportation%20equipment%2C%20clean%20medical%20transport%20stretcher%2C%20healthcare%20emergency%20transport%20vehicle%2C%20professional%20medical%20equipment%2C%20simple%20clean%20background%20highlighting%20stretcher%2C%20sterile%20medical%20environment&width=600&height=500&seq=service-stretcher-003&orientation=portrait',
      category: 'Stretcher Services',
      title: 'Stretcher Transportation',
      description: 'Specialized vehicles equipped with medical-grade stretchers for patients requiring horizontal transport.'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-start justify-between mb-16 gap-8">
          <div className="lg:w-1/3">
            <p className="text-4xl text-gray-400 uppercase tracking-wide mb-2" style={{ fontFamily: 'Inter, sans-serif' }}>
              COMPREHENSIVE
            </p>
            <h2 className="text-5xl font-semibold text-gray-900 italic" style={{ fontFamily: 'Playfair Display, serif' }}>
              Transportation Solutions
            </h2>
          </div>
          <div className="lg:w-2/3">
            <p className="text-lg text-gray-600 leading-relaxed">
              We provide specialized non-emergency medical transportation services tailored to your unique mobility needs. Our professional drivers and modern fleet ensure safe, comfortable, and reliable transport to all your medical appointments.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-lg transition-shadow">
              <div className="w-full h-80">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-center"
                />
              </div>
              <div className="p-6">
                <span className="inline-block px-4 py-1.5 bg-teal-100 text-teal-800 rounded-full text-sm font-medium mb-4 whitespace-nowrap">
                  {service.category}
                </span>
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-base text-gray-600 mb-4 leading-relaxed">
                  {service.description}
                </p>
                <a href="#contact" className="inline-flex items-center text-teal-600 font-semibold hover:text-teal-700 transition-colors cursor-pointer">
                  Learn More
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
